import React from "react";
import Header from "../../components/header/Header";
import Hero from "../../assets/images/svg/hero.svg";
import vector from "../../assets/images/svg/Vector.svg";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import ButtonOutlined from "../../components/buttons/ButtonOutlined";
import globe from "../../assets/icons/globe.svg";
import arrow from "../../assets/icons/arrow.svg";
import location from "../../assets/icons/location.svg";

function Landing() {
  return (
    <div className="vh-100 d-flex flex-column justify-content-between hero">
      <Header />
      <div className="w-100 d-flex align-items-center justify-content-center position-relative container h-auto">
        <img
          className="w-100"
          src={Hero}
          alt="Hero"
          style={{ objectFit: "contain" }}
        />
        <div className="position-absolute bottom-0 hero-content">
          <img src={vector} alt="vector" className="ms-auto d-flex" />
          <div className="black-gradient-background">
            <div className="d-flex flex-column align-items-center gap-3 ">
              <ButtonOutlined
                text={
                  <div className="d-flex gap-2 px-2">
                    {" "}
                    <img src={globe} alt="globe" style={{ height: "24px" }} />
                    <img src={arrow} alt="globe" />
                    <img
                      src={location}
                      alt="globe"
                      style={{ height: "24px" }}
                    />
                  </div>
                }
              />
              <h2 className="primary-hero-color oswald-Bold font-64 text-center">
                GLOBAL VISION, LOCAL SUCCESS.
              </h2>

              <p className="text-light  letter-spacing-2  text-center line-height-36 font-20 width-60">
                We don't just build software. We engineer successful products
                for the Indian market by adapting proven global business models.
              </p>
            </div>

            <div className="d-flex gap-4 justify-content-center mt-2 flex-wrap">
              
              <ButtonPrimary text="LET'S BUILD YOUR NEXT SUCCESS STORY" target="why-geesez"/>
              <ButtonOutlined text="Learn more" target="our-approach"/>
            </div>
          </div>
        </div>
      </div>

      <p className="text-transform-uppercase font-13 letter-spacing-2 text-light text-center">
        Scroll to Explore
      </p>
    </div>
  );
}

export default Landing;
